(function () {
  'use strict';

  var MODELS = [
    { label: 'AirPods Pro 3', handle: 'airpods-pro-3-cases' },
    { label: 'AirPods Pro 2', handle: 'airpods-pro-2-cases' },
    { label: 'AirPods Pro', handle: 'airpods-pro-cases' },
    { label: 'AirPods 5', handle: 'airpods-5-cases' },
    { label: 'AirPods 4', handle: 'airpods-4-cases' },
    { label: 'AirPods 3', handle: 'airpods-3-cases' },
    { label: 'AirPods Max', handle: 'airpods-max-cases' }
  ];

  function getGenderFilterSuffix() {
    var params = new URLSearchParams(window.location.search);
    var view = params.get('view') || '';
    var isMen = view.indexOf('men') !== -1 || sessionStorage.getItem('gender') === 'men';
    var filterValue = isMen ? 'male,unisex' : 'female,unisex';
    return '?filter.p.m.custom.product_gender_context=' + filterValue;
  }

  function init(container) {
    if (container.dataset.initialized) return;
    container.dataset.initialized = 'true';

    var modelSelect = container.querySelector('[data-model-select]');

    modelSelect.innerHTML = MODELS.map(function (m) {
      return '<option value="' + m.handle + '">' + m.label + '</option>';
    }).join('');

    var pathHandle = window.location.pathname.split('/').filter(Boolean).pop() || '';
    var matchingModel = MODELS.find(function (m) { return m.handle === pathHandle; });
    if (matchingModel) modelSelect.value = matchingModel.handle;

    modelSelect.addEventListener('change', function () {
      if (modelSelect.value) {
        window.location.href = '/collections/' + modelSelect.value + getGenderFilterSuffix();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[id^="BudsSelector-"]').forEach(function (el) {
      init(el);
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
})();